
export default {
  name: 'DropdownElementTaco',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
};
